import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { ClienteCentralCompraV1 } from './cliente-central-compra-v1';

@Injectable({
    providedIn: 'root'
})
export class ClienteCentralCompraV1HttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/cliente`;
    }

    /** Verifica se o cliente através do ID do cliente é uma Central de Compra que possui outros clientes vinculados a ela */
    isCentralCompraComClientesVinculados(idCliente: number): Observable<boolean> {
        return this.customHttp.get<boolean>(`${this.pathApi}/${idCliente}/centralcomprav1`);
    }

    /** Pesquisa os clientes vinculados a mesma Central de Compra do Cliente através do cliente informado */
    searchClientesVinculadosCentralCompra(idCliente: number, incluirCentralCompra: boolean): Observable<ClienteCentralCompraV1[]> {
        // Params
        const params = new HttpParams()
                            .append('incluirCentralCompra', incluirCentralCompra.toString());

        return this.customHttp.get<ClienteCentralCompraV1[]>(`${this.pathApi}/${idCliente}/centralcomprav1/vinculado`, {params});
    }

    /** Desvincula o cliente informado da sua Central de Compras */
    desvincularCentralCompra(id: number): Observable<string> {
        return this.customHttp.put<string>(`${this.pathApi}/${id}/centralcomprav1/desvincular`, null, {responseType: 'text'});
    }
}
